module.exports = __webpack_public_path__ + "img/hero-extra-card.fc62a85.svg";